import { Camera } from "expo-camera";
import { useContext, useRef } from "react";
import { CameraContext } from "./context";

export function useCamera() {
  const cameraRef = useRef<Camera>(null);

  return { cameraRef };
}

export const useCameraContext = () => {
  const context = useContext(CameraContext);

  if (!context) {
    throw new Error("useCameraContext must be used within a CameraProvider");
  }

  return context;
};
